import React, { useState } from 'react'
import { SubscriptionAmountChange } from '../SubscriptionAmountChange'
import { ChangeContractDialog } from './common/ChangeContractDialog'
import { Contract } from '../../../../../types/contract'
import { ContractPaymentInfoBanner } from '../ContractPaymentBanner'
import { translations } from '../../../../../utils/translations/translations-manager'
export function SubscriptionAmountChangeDialog({
  subscription,
  visible,
  initialValue,
  close,
  success,
}: {
  subscription: Contract
  visible: boolean
  initialValue?: number
  close: () => void
  success: () => void
}): JSX.Element {
  if (!subscription.charityId || !subscription._id) throw new Error('Charity ID and Subscription ID must be defined')
  // Completed used to handle right closing the dialog after the change was successful as success
  const [completed, setCompleted] = useState(false)

  return (
    <ChangeContractDialog
      visible={visible}
      close={completed ? success : close}
      title={completed ? translations.texts.donation_updated.toString() : translations.texts.change_amount.toString()}
    >
      {!completed && <ContractPaymentInfoBanner contract={subscription} className="mb-8" />}
      <SubscriptionAmountChange
        charityId={subscription.charityId}
        contractId={subscription._id}
        initialValue={initialValue}
        success={success}
        complete={() => setCompleted(true)}
        cancel={close}
      />
    </ChangeContractDialog>
  )
}
